import React, { useEffect, useState } from 'react'
import ConfirmAlert from '../../../components/common/ConfirmAlert'
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from 'shards-react';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import { setAlert } from '../../../redux/actions/alert';
import { NavgationPageLocationKey } from '../../../utils/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getSubscriberProjectStatusClass } from '../../../utils/general';
import { bulk_sub_client_delete_project, bulk_update_sub_client_project_status, get_sub_client_project_list, get_sub_project_status_list, reset_client_project_list, set_client_project_bulk_update } from '../../../redux/actions/subscriber/project';
import Multiselect from 'multiselect-react-dropdown';

const CHANGE_STATUS = 'CHANGE_STATUS';
const DELETE_PROJECT = 'DELETE_PROJECT';
const STATUS_ALL = 'All Statuses';
const ViewProject = ({ subClientProjectList, subClientProjectStatusList, bulkUpdateClientProject
    , reset_client_project_list, get_sub_client_project_list, get_sub_project_status_list, setAlert
    , bulk_sub_client_delete_project, bulk_update_sub_client_project_status, set_client_project_bulk_update
}) => {
    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });

    const initialState = {
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        projectName: '',
        client: '',
        status: '',
        bulkAction: ''
    }
    const [formData, setFormData] = useState({ status: '' })
    const [state, setState] = useState({ ...initialState });
    const [tableData, setTableData] = useState([]);
    const history = useHistory();
    const defaultStatus = [{ cat: '', key: '' }];
    const [selectedValues, setSelectedValues] = useState([...defaultStatus]);
    const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);

    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const onCheck = (refNum) => {
        let checkedTableData = tableData.map(data => {
            if (data.refNum === refNum) {
                data.checked = !data.checked
            }

            return data;
        })

        setTableData(checkedTableData);
    }
    const checkAll = (e) => {
        let checkedTableData = tableData.map(data => {
            data.checked = e.target.checked;
            return data;
        })
        setTableData(checkedTableData);
    }
    const isAllChecked = () => {
        if (tableData.length === 0)
            return false

        for (let data of tableData) {
            if (!data.checked) {
                return false;
            }
        }
        return true;
    }
    const { pageSize, pageSizeOptions } = state;

    const deleteProject = (refNumArray) => {
        setConfirmAlert({
            confirmAlert,
            confirmMsg: 'Are you sure you want to delete project(s)?',
            visible: true,
            onConfirm: async () => {
                await bulk_sub_client_delete_project({ refNumList: refNumArray });
                setConfirmAlert({
                    confirmAlert,
                    visible: false
                })
                get_sub_client_project_list("", "", "");
                setState({ ...state, bulkAction: '' });
            }
        })
    }

    const tableColumns = [
        {
            Header: <input type="checkbox" checked={isAllChecked()} onClick={(e) => checkAll(e)} />,
            accessor: "action",
            maxWidth: 50, minWidth: 50,
            sortable: false,
            Cell: row => <input type="checkbox" checked={row.original.checked} key={row.original.refNum}
                onClick={() => onCheck(row.original.refNum)} />
        },
        {
            Header: "Project #",
            accessor: "refNum",
            maxWidth: 130, minWidth: 130,
            Cell: row => <>
                <span className="p-0"><img src="./icons/edit-square.svg" height="17.5" width="17.5" className='icon-cursor mr-1' role="button"
                    onClick={(e) => { openProjectInNewTab(e, row.original.refNum) }}></img>
                </span>
                <a href="/add-edit-project" onClick={(e) => { openProjectInNewTab(e, row.original.refNum) }}
                    onContextMenu={(e) => onContextMenuProjectChange(e, row.original.refNum)}>
                {row.original.projectRefNum}
            </a>
            </>
        },
        {
            Header: "Project",
            accessor: "project",
            minWidth: 100,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.projectName}>{row.original.projectName}</span>
        },
        {
            Header: "Client",
            accessor: "client",
            minWidth: 100,
            classNames: 'text-left',
            Cell: row => <span className="w-100 text-left" title={row.original.clientName}>{row.original.clientName}</span>
        },
        {
            Header: "Status",
            accessor: "status",
            maxWidth: 150, minWidth: 100,
            className: "text-center",
            Cell: row => <span className={getSubscriberProjectStatusClass(row.original.status)}>{row.original.status}</span>,
        },
        {
            Header: "",
            accessor: "action",
            maxWidth: 50, minWidth: 50,
            Cell: row =>
                <span className="p-1" role="button" onClick={() => {
                    deleteProject([row.original.refNum], true);
                }}><img src="./icons/cross-icon.png" height="17.5" width="17.5" className='icon-cursor'/></span>
        }
    ]

    useEffect(() => {
        get_sub_project_status_list();
        get_sub_client_project_list("", "", "");
        
        return () => {
            reset_client_project_list();
        }
    }, [])

    const navigateToAddProject = (e) => {
        navigateToProject(e, 0);
    }
    
    function navigateToProject(e, refId){
        e.preventDefault(); 
        history.push({
            pathname: `/add-edit-project`,
            state: { refNum: refId }
        });
        return false;
    }

    function onContextMenuProjectChange(e, refId){
        if(e.type === 'contextmenu'){
            localStorage.setItem(NavgationPageLocationKey.ProjectCurrentAddEdit, refId);
        }
    }

    function openProjectInNewTab(e, refId) {
        e.preventDefault();
        localStorage.setItem(NavgationPageLocationKey.ProjectCurrentAddEdit, refId);
        window.open('/add-edit-project', '_blank');
    }

    const reset = () => {
        setState({ ...initialState })
        setSelectedValues([...defaultStatus])
        get_sub_client_project_list("", "", "");
    }

    const onSearch = (e) => {
        e.preventDefault()
        const selectedStatus = selectedValues.map(status => status.key).toLocaleString();
        get_sub_client_project_list(state.projectName, state.client, selectedStatus);
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (e.nativeEvent.submitter.name === 'set') {
            let projectRefNum = tableData.filter(data => data.checked).map(mapData => mapData.refNum)
            if(projectRefNum.length === 0){
                setAlert("Please select records to perform action!", "danger")
                return;
            }
            const updated = await bulk_update_sub_client_project_status({ refList: [...projectRefNum], status: formData.status });
            if (updated) {
                const selectedStatus = selectedValues.map(status => status.key).toLocaleString()
                get_sub_client_project_list(state.projectName, state.client, selectedStatus);
            }
            setFormData({ ...formData, status: '' })
        }
        else if(e.nativeEvent.submitter.name === 'yes') {
            let projectRefNum = tableData.filter(data => data.checked).map(mapData => mapData.refNum);
            if(projectRefNum.length === 0){
                setAlert("Please select records to perform action!", "danger")
                return;
            }
            const updated = await bulk_sub_client_delete_project({ refNumList: [...projectRefNum] });
            if (updated) {
                const selectedStatus = selectedValues.map(status => status.key).toLocaleString()
                get_sub_client_project_list(state.projectName, state.client, selectedStatus);
            }
        }
        else {
            set_client_project_bulk_update();
        }
        setState({ ...state, bulkAction: '' });
    }
    
    useEffect(() => {
        let projectStatus = subClientProjectStatusList.map(status => ({
            cat: status,
            key: status
        }))

        setStatusDropdownOptions([{
            cat: '',
            key: STATUS_ALL
        }, ...projectStatus])
    }, [subClientProjectStatusList])

    useEffect(() => {
        setTableData(subClientProjectList);
    }, [subClientProjectList])

    var statusList = subClientProjectStatusList?.map((item, i) => {
        return <option key={item + i} value={item}>{item}</option>
    })

    const [openModal, setOpenModal] = useState(false);
    const toggle = () => {
        setOpenModal(!openModal);
        setState({ ...state, bulkAction: '' });
    }
    useEffect(() => {
        setOpenModal(state.bulkAction === CHANGE_STATUS || state.bulkAction === DELETE_PROJECT)
    }, [state.bulkAction])

    return (
    <>
        <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert}/>
        <Container fluid className="main-content-container px-4 pb-4">
            <Modal size="md" fade={false} style={{ width: '500px' }} backdrop={false} className="d-flex align-items-center justify-content-center w-auto h-100" open={openModal} toggle={toggle}>
                <div className="d-flex justify-content-end p-1 mx-2"><i class="fa-solid fa-xmark primary-text bg-white" role="button" onClick={toggle}></i></div>
                <ModalBody className={!bulkUpdateClientProject ? "px-5" : 'px-0'}>
                    <div>
                        <Form onSubmit={onSubmit}>
                            {state.bulkAction === CHANGE_STATUS ? !bulkUpdateClientProject ? <Row className="w-100">
                                <Col lg="6" className="my-auto pb-4">
                                    <label className="h4 font-weight-bold my-auto">Set Status:</label>
                                </Col>
                                <Col lg="6" className="px-0 pb-4">
                                    <FormSelect name='setStatus'
                                        value={formData.status}
                                        onChange={(e) => setFormData({ status: e.target.value })}
                                    >
                                        <option value=''>Select Status</option>
                                        { statusList }
                                    </FormSelect>
                                </Col>
                                <Col lg="6"></Col>
                                <Col lg="6" className="d-flex flex-row justify-content-between px-0">
                                    <Button name="set" className="px-4">Set</Button>
                                    <Button name="cancel" onClick={toggle} className="px-4">Cancel</Button>
                                </Col>
    
                            </Row> :
                                <Row className="w-100 pb-2 d-flex flex-row justify-content-center pl-4">
                                    <Col lg="12" className="my-auto pb-4 tex-center pl-2 px-0">
                                        <label className="font-weight-bold my-auto">The status has been changed to 
                                            <span><label className="primary-text">{formData.status}</label></span>
                                            for the selected items
                                        </label>
                                    </Col>
                                    <Col lg="12" className="d-flex flex-row justify-content-center">
                                        <div className="d-flex flex-row justify-content-between">
                                            <Button name="cancel" onClick={toggle} className="px-4 mx-2">Close</Button>
                                        </div>
                                    </Col>
    
                                </Row>
                                : !bulkUpdateClientProject ?
                                    <Row className="w-100 pb-2 d-flex flex-row justify-content-center pl-4">
                                        <Col lg="12" className="my-auto pb-4 tex-center">
                                            <label className="font-weight-bold my-auto">
                                                Are you sure you want to delete Project(s)?
                                            </label>
                                        </Col>
                                        <Col lg="12" className="d-flex flex-row justify-content-center">
                                            <div className="d-flex flex-row justify-content-between">
                                                <Button name="yes" className="px-4 mx-2">Yes</Button>
                                                <Button name="cancel" onClick={toggle} className="px-4 mx-2">Cancel</Button>
                                            </div>
                                        </Col>
                                    </Row>
                                    :
                                    <Row className="w-100 pb-2 d-flex flex-row justify-content-center pl-4">
                                        <Col lg="12" className="my-auto pb-4 text-center pl-3">
                                            <label className="font-weight-bold my-auto">This feature is currently not available.</label>
                                        </Col>
                                        <Col lg="12" className="d-flex flex-row justify-content-center">
                                            <div className="d-flex flex-row justify-content-between">
                                                <Button name="cancel" onClick={toggle} className="px-4 mx-2">Close</Button>
                                            </div>
                                        </Col>
    
                                    </Row>
                            }
                        </Form>
                    </div>
                </ModalBody>
            </Modal>
            <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

                <div className="d-flex align-items-center p-2">
                    <FormInput name='projectName' value={state.projectName}
                        onChange={onChange} placeholder="Project Name"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <FormInput name='client' value={state.client}
                        onChange={onChange} placeholder="Client"
                    />
                </div>

                <div className="d-flex align-items-center p-2">
                    <Multiselect
                        hideSelectedList
                        displayValue="key"
                        placeholder={`Status: ${(selectedValues && selectedValues.length > 0 && selectedValues[0].key === STATUS_ALL) ? STATUS_ALL : selectedValues.map(val => val.key).toString()}`}
                        onKeyPressFn={function noRefCheck() { }}
                        onSearch={function noRefCheck() { }}
                        onRemove={function noRefCheck(selectedOptions, item) {
                            if (item.key === STATUS_ALL) {
                                setSelectedValues([])
                            } else {
                                selectedOptions = selectedOptions.filter(option => option.key !== STATUS_ALL)
                                setSelectedValues([...selectedOptions])
                            }
                        }}
                        onSelect={function noRefCheck(selectedOptions, seletedItem) {
                            if (seletedItem.key === STATUS_ALL) {
                                setSelectedValues([...statusDropdownOptions])
                            } else {
                                if (selectedOptions.length === statusDropdownOptions.length - 1) {
                                    selectedOptions = [...statusDropdownOptions]
                                }
                                setSelectedValues([...selectedOptions])
                            }
    
                        }}
                        options={[
                            ...statusDropdownOptions
                        ]}
                        selectedValues={[...selectedValues]}
    
                        showCheckbox />
                </div>

                <div className="d-flex align-items-center justify-content-end p-2">
                    <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                        onClick={onSearch}>Search</Button>
                    <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                        Reset
                    </Button>
                </div>
            </div>


            <Card className="tableCard p-0">
                <CardHeader className="p-0">
                    <Container fluid className="file-manager__filters border-bottom">
                        <Row>
                            {/* Filters :: Page Size */}

                            <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                                <span>
                                    <FormSelect size="sm" name='bulkAction' className="w-100"
                                        value={state.bulkAction} onChange={onChange}
                                    >
                                        <option key="bulkActions0" value="">Bulk Actions</option>
                                        <option key="changeStatus1" value={CHANGE_STATUS}>Change Status</option>
                                        <option key="deleteProject" value={DELETE_PROJECT}>Delete</option>
                                    </FormSelect>
                                </span>
                            </Col>
                            <Col lg="3" className="d-flex align-items-center">
                                {/* <Button className="mx-2 py-2 my-2" size='sm' theme="accent">Add Timesheet</Button> */}
                            </Col>
                            <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                                <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={navigateToAddProject}>
                                    New Project
                                </Button>
                            </Col>

                            <Col lg="1"
                                className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                <span>Show</span>
                                <FormSelect
                                    size="sm"
                                    name='pageSize'
                                    value={state.pageSize}
                                    onChange={onChange}
                                >
                                    {pageSizeOptions.map((size, idx) => (
                                        <option key={idx} value={size}>
                                            {size} rows
                                        </option>
                                    ))}
                                </FormSelect>
                            </Col>
                        </Row>
                    </Container>
                </CardHeader>
                <CardBody className="p-0">
                    <div className="">
                        <ReactTable
                            columns={tableColumns}
                            data={tableData}
                            pageSize={Number(pageSize)}
                            showPageSizeOptions={false}
                            resizable={false}
                            noDataText="No results found"
                        />
                    </div>
                </CardBody>
            </Card>
        </Container>
    </>
    )
}

const mapStateToProps = (state) => ({
    subClientProjectStatusList: state.project.subClientProjectStatusList,
    subClientProjectList: state.project.subClientProjectList,
})

export default connect(mapStateToProps, {
    get_sub_project_status_list,
    get_sub_client_project_list,
    bulk_sub_client_delete_project,
    bulk_update_sub_client_project_status,
    reset_client_project_list,
    setAlert,
    set_client_project_bulk_update,
})(ViewProject)
